import React from "react";
/* ---------------------- 🔹 Sources Button ---------------------- */
export default function CitationButton({ citations, onClick }) {
    const firstThree = citations.slice(0, 3);
    const faviconUrl = (url) => {
        try {
            const host = new URL(url).hostname;
            return `https://www.google.com/s2/favicons?domain=${encodeURIComponent(host)}&sz=64`;
        } catch {
            return "";
        }
    };

    return (
        <button
            onClick={onClick}
            className="flex items-center gap-2 bg-blue-50 hover:bg-blue-100 text-blue-700 text-sm px-3 py-1 rounded-full border border-blue-200 transition"
        >
            <div className="flex -space-x-2">
                {firstThree.map((url, i) => (
                    <img
                        key={i}
                        src={faviconUrl(url)}
                        alt="favicon"
                        className="w-5 h-5 rounded-full border border-white bg-white"
                        onError={(e) => {
                            e.currentTarget.style.visibility = "hidden";
                        }}
                    />
                ))}
            </div>
            <span className="font-medium">{citations.length} sources</span>
        </button>
    );
}
